/**
 * PLATFORM-DESIGN-SYSTEM-CODIFICATION-V1 -- S3 PRIMARY ACTION (the third
 * AdoraCare signature; owner-home/SYSTEM-EXTRACT.md S3 + conformance
 * C-4; the money one-primary law,
 * money-workspace/CONFORMANCE-CONTRACT.md s.2).
 *
 * THE THREE ACTION TIERS, named. All three are thin compositions over
 * the EXISTING AcButton primitive (component.ac-button stays the ONE
 * button owner -- this file forks nothing):
 *  - PrimaryAction  = AcButton variant="primary"  (filled; exactly ONE
 *    per page state, carried on the top exception / the act in
 *    progress);
 *  - SecondaryAction = AcButton variant="secondary" (outline; every
 *    demoted action);
 *  - QuietAction    = AcButton variant="ghost" (borderless quiet verb /
 *    row affordance).
 *
 * THE LAWS, and where each is enforced:
 *  - ONE PRIMARY PER STATE: measurable census = ui/shell.ts
 *    countPrimaryActions (existing; tests assert <= 1) -- reused, not
 *    re-derived.
 *  - COPY = verb + object with the real count ("Claim 41 leads") or verb
 *    + named object ("Close Kukatpally's Tue 04 Aug"); never a passive
 *    read verb as primary; no manufactured urgency. Pure check =
 *    ui/lexicon.ts primaryActionCopyViolation (pinned in tests; surface
 *    suites run it over their primary labels).
 *  - Quiet/healthy states: the primary SLOT renders the healthy
 *    composition, never a button (owner C-4) -- a page rule, proven per
 *    surface.
 *
 * PRESENTATION-ONLY; selection/ranking is config-backed page logic
 * (owner_home.exception_rank et al.), never decided here.
 */

import { forwardRef } from 'react';
import AcButton, { type AcButtonProps } from './AcButton';

export type ActionTierProps = Omit<AcButtonProps, 'variant'>;

/** The ONE filled primary of a page state (S3). */
export const PrimaryAction = forwardRef<HTMLButtonElement, ActionTierProps>(
  function PrimaryAction(props, ref) {
    return <AcButton {...props} ref={ref} variant="primary" />;
  },
);

/** A demoted outline action (everything that is not the one primary). */
export const SecondaryAction = forwardRef<HTMLButtonElement, ActionTierProps>(
  function SecondaryAction(props, ref) {
    return <AcButton {...props} ref={ref} variant="secondary" />;
  },
);

/** A quiet borderless verb / row affordance. */
export const QuietAction = forwardRef<HTMLButtonElement, ActionTierProps>(
  function QuietAction(props, ref) {
    return <AcButton {...props} ref={ref} variant="ghost" />;
  },
);

export default PrimaryAction;
